import { Controller } from "@hotwired/stimulus"

// Highlights the table-of-contents link of the section being read
export default class extends Controller {
  static targets = ["link"]

  connect() {
    const sections = this.linkTargets.map((link) => document.getElementById(link.hash.slice(1))).filter(Boolean)
    this.observer = new IntersectionObserver((entries) => {
      const visible = entries.filter((entry) => entry.isIntersecting)
      if (visible.length) this.activate(visible[0].target.id)
    }, { rootMargin: "-15% 0px -75% 0px" })
    sections.forEach((section) => this.observer.observe(section))
  }

  disconnect() {
    this.observer.disconnect()
  }

  activate(id) {
    this.linkTargets.forEach((link) => {
      const active = link.hash === "#" + id
      link.classList.toggle("is-active", active)
      if (active) link.setAttribute("aria-current", "location")
      else link.removeAttribute("aria-current")
    })
  }
}
